import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const EditorContainer = styled(Box)(({ theme }) => ({
  bgcolor: theme.palette.background.default
})); 